module.exports = __webpack_public_path__ + "3f16e137/img/ion_calendar-number.3ac5bd07.svg";